import { render, staticRenderFns } from "./MeasurementsTable.vue?vue&type=template&id=01ad4731&scoped=true&"
import script from "./MeasurementsTable.vue?vue&type=script&lang=js&"
export * from "./MeasurementsTable.vue?vue&type=script&lang=js&"
import style0 from "./MeasurementsTable.vue?vue&type=style&index=0&id=01ad4731&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ad4731",
  null
  
)

export default component.exports